import { useEffect, useState } from 'react';
import { getEnumLibreCials } from '../PaymentServices';

const INITIAL = {
  pickers: [],
  packeds: [],
  billers: [],
  others: [],
};
const useOpsEnumLibreCial = () => {
  const [enumLibreCials, setEnumLibreCials] = useState(INITIAL);
  const [loading, setLoading] = useState(false);

  useEffect(async () => {
    try {
      setLoading(true);
      const data = await getEnumLibreCials();
      const list = data.reduce((acc, item) => {
        switch (item.userType) {
          case 1: // Facturé par
            acc.billers.push(item);
            break;
          case 2: // Piqué par
            acc.pickers.push(item);
            break;
          case 5: // Embalé par
            acc.packeds.push(item);
            break;
          default:
            acc.others.push(item);
        }
        return acc;
      }, INITIAL);
      setEnumLibreCials(list);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, enumLibreCials };
};

export default useOpsEnumLibreCial;
